import { Commit } from 'vuex';
import { EstimateRequestState } from '.';

export interface EstimateModuleActionTypes{
    commit: Commit,
    state: EstimateRequestState,
    getters: any
}

export enum EstimateModuleAction{
    SEND_ASK_ESTIMATE = 'ESTIMATE_SEND_ASK_ESTIMATE',
    UPDATE_ASK_ESTIMATE = 'ESTIMATE_UPDATE_ASK_ESTIMATE',
}
